import { RankingStatusBadgeEnum } from '@/types/types';

export interface PlayerTournamentsData {
  tournamentUuid: string;
  clubId: string;
  locationCity: string;
  locationCountry: string;
  locationState: string;
  locationStreetAddress: string;
  locationVenue: string;
  logo: string;
  registrationCount: number;
  title: string;
  tourneyFromDate: string;
  slug: string;
  waitingListCount?: number;
  paymentCurrencyAbbreviation: string;
  tourneyToDate: string;
  costRegistrationCurrent: number;
  isRegClosed: boolean;
  cancelTourney: boolean;
  costFeeOnEvents: boolean;
  isPrizeMoney?: boolean;
  isFeatured?: boolean;
  hideRegisteredPlayers?: boolean;
  isFavorite?: boolean;
  badgeTitle?: RankingStatusBadgeEnum;
  showBadgeTitle?: boolean;
}

export interface MyTournament {
  AcceptedPayment_PayPal_Active: boolean;
  ActivateRefereeSignup: boolean;
  ActivateVolunteerSignup: boolean;
  ActivityTotal: number;
  AdvertiseOnly: boolean;
  AttendeeHeaderID: string;
  AttendeeTotal: number;
  Caption: string;
  ClubID: string;
  Coo_CanManageActivities: number;
  Coo_CanManageAttendees: number;
  Coo_CanManageCheckin: number;
  Coo_CanManageEvent: number;
  Coo_CanManagePayments: number;
  Coo_CanManageReferees: number;
  Coo_CanManageScores: number;
  Coo_CanManageVolunteers: number;
  Coo_CanViewOnly: number;
  Coo_CanViewReports: number;
  Coo_IsPrimary: number;
  Cost_FeeOnEvents: string;
  Cost_Registration_Current: string;
  DateFrom: string;
  DateLocked: string;
  DateTo: string;
  DisplayArea: string;
  EventSetup_StepsCompleted: number;
  HideRegisteredPlayers: boolean;
  ID: string;
  IsCanceled: boolean;
  IsFavorite: number;
  IsLocked: number;
  IsNonPlayerRecord: boolean;
  IsReadOnlyMode: boolean;
  IsRegClosed: boolean;
  IsStub: boolean;
  LocationOfEvent_City: string;
  LocationOfEvent_CountryAbbreviation: string;
  LocationOfEvent_StateAbbreviation: string;
  LocationOfEvent_StreetAddress: string;
  LocationOfEvent_Venue: string;
  LocationOfEvent_Zip: string;
  Logo: string;
  ModuleID: string;
  OnlineRegistration_Active: boolean;
  PaymentCurrencyAbbreviation: string;
  RegistrationCount: number;
  Registration_DateClosed: string;
  Registration_DateOpen: string;
  SponsorLogo: string;
  SponsorTitle: string;
  Slug: string;
  Tagline: string;
  TimeZone: string;
  TimeZoneHasDST: boolean;
  TimeZoneIanaID: string;
  TimeZoneName: string;
  TimeZoneTitleExtended: string;
  TimeZoneUTCOffset: number;
  Title: string;
  TitleSponsor_Logo: string;
  TitleSponsor_Tagline: string;
  TitleSponsor_Title: string;
  TitleSponsor_URL: string;
  TotalOwe: string;
  Tourney_Managing_CanManageActivities: number;
  Tourney_Managing_CanManageAttendees: number;
  Tourney_Managing_CanManageCheckin: number;
  Tourney_Managing_CanManageEvent: number;
  Tourney_Managing_CanManagePayments: number;
  Tourney_Managing_CanManageReferees: number;
  Tourney_Managing_CanManageScores: number;
  Tourney_Managing_CanManageVolunteers: number;
  Tourney_Managing_IsPrimary: number;
  URL: string;
  showResultsButton: number;
}

export interface TournamentFavoritesData {
  tournamentId: string;
  tourneyFromDate: string;
  tourneyToDate: string;
  isRegClosed: boolean;
  logo: string;
  registrationDateClosed: string;
  registrationDateOpen: string;
  title: string;
  slug: string;
  locationCity: string;
  locationCountry: string;
  locationState: string;
  registrationCount: string;
  timeZoneUtcOffset: number;
  costRegistrationCurrent: string;
  paymentCurrencyAbbreviation: string;
  costFeeOnEvents: string;
  distance: string;
  ClubID: string;
  Platform: string;
  PBTournamentCode: string;
  TimeZoneAbbreviation: string;
  showDraws: string;
  duprUserPercentage: number;
  locationVenue: string;
  additionalImages: string;
  isFavourite: boolean;
  hideRegisteredPlayers: boolean;
  hideRegisteredPlayersInt: string;
  isAdvertiseOnly: boolean;
  impressions: string;
  clicks: string;
  uniqueImpressions: string;
  uniqueClicks: string;
  isTest: boolean;
}

export interface PlayerFavorite {
  moduleFor: string;
  moduleUuid: string;
  userUuid: string;
  dateCreated: string;
  dateDisabled: string | null;
  moduleData: TournamentFavoritesData;
  tournamentRank?: number;
  badgeTitle?: RankingStatusBadgeEnum;
  showBadgeTitle?: boolean;
}

export enum TournamentStatus {
  Future = 'Future',
  Past = 'Past',
}

export const statusMap: Record<string, TournamentStatus> = {
  true: TournamentStatus.Future,
  false: TournamentStatus.Past,
};
